export default __webpack_public_path__ + "static/media/device_1.f3f2f45f.svg";